'use client';

import type { Metadata } from 'next';
import { useEffect } from 'react';

import { ErrorLayout } from '@/app/components/error-layout';
import { ERROR_DATA } from '@/app/contents/error-layout';
import { CV_METADATA } from '@/app/cv/contents/metatag';
import { LCV_METADATA } from '@/app/lcv/contents/metatag';
import type { VehicleType } from '@/app/types/vehicle-type';

const vehicleType = `${process.env.NEXT_PUBLIC_WEB}` as VehicleType;

let metaTitle;
const META_DESCRIPTION = ERROR_DATA[500].description;

switch (vehicleType) {
  case 'cv':
    metaTitle = '500 - ISUZU TRUCKS Thailand Official';
    break;
  case 'lcv':
    metaTitle = '500 - อีซูซุประเทศไทย Isuzu Thailand Official';
    break;
}

export const metadata: Metadata = {
  title: metaTitle,
  description: META_DESCRIPTION,
  openGraph:
    vehicleType === 'lcv'
      ? {
          ...LCV_METADATA.openGraph,
          title: metaTitle,
          description: META_DESCRIPTION,
        }
      : {
          ...CV_METADATA.openGraph,
          title: metaTitle,
          description: META_DESCRIPTION,
        },
  alternates:
    vehicleType === 'lcv' ? LCV_METADATA.alternates : CV_METADATA.alternates,
};

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    window.onerror = function (message, url, line, column, error) {
      // eslint-disable-next-line no-console
      console.log(message, url, line, column, error);
    };
  }, [error]);

  return <ErrorLayout vehicleType={vehicleType} status="500" />;
}
